import React from "react";
import styled from "styled-components";

import MaterialButton from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModalService } from "../service/modal-service";
import { Col, Text, Button, Row, Img } from "../comps";
import { Theme } from "../theme/theme-provider";

import { faGlobe, faCode } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { ankitImg } from "../theme/uploaded";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  align-items: center;
`;

const Head = styled(Col)`
  width: 90%;
  margin-top: 5px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_2};
`;

const ButtonWrapper = styled(Row)`
  margin-top: 18px;
  justify-content: space-between;
`;

export default ({ title, handleSubmit, yes, no, shouldNotClose }) => {
  const handleAccept = () => {
    handleSubmit();
    if (!shouldNotClose) ModalService.closeModal();
  };

  const handleReject = () => {
    if (!shouldNotClose) ModalService.closeModal();
  };

  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="24px"
          width="90%"
          color={Theme.color.BLUE_3}
          fontFamily={Theme.fontFamily.cursive}
          textAlign="center"
        >
          {`DEVELOPER`}
        </Text>
      </Head>
      <Img
        src={ankitImg}
        width="30%"
        round={true}
        style={{ marginTop: "2%" }}
      />
      <Text
        fontSize="20px"
        width="90%"
        color={Theme.color.BLUE_3}
        fontFamily={Theme.fontFamily.cursive}
        textAlign="center"
        style={{ marginTop: "2%" }}
      >
        {`ANKIT VERMA`}
      </Text>
      {/* linkedin */}
      <MaterialButton
        style={{ width: "80%", marginTop: "4%" }}
        variant="outlined"
        color="primary"
        href="https://www.linkedin.com/in/ankit-verma-03308215a/"
        target="_blank"
        startIcon={
          <FontAwesomeIcon
            style={{ color: Theme.color.BLUE_3 }}
            icon={faLinkedin}
          />
        }
      >
        Linkedin
      </MaterialButton>
      {/* portfolio */}
      <MaterialButton
        style={{ width: "80%", marginTop: "1%" }}
        variant="outlined"
        color="secondary"
        href="https://avcbcoder.github.io/"
        target="_blank"
        startIcon={
          <FontAwesomeIcon
            style={{ color: Theme.color.RED_3 }}
            icon={faGlobe}
          />
        }
      >
        Portfolio
      </MaterialButton>
      {/* codechef */}
      <MaterialButton
        style={{ width: "80%", marginTop: "1%" }}
        variant="outlined"
        color="primary"
        href="https://www.codechef.com/users/avcbcoder"
        target="_blank"
        startIcon={
          <FontAwesomeIcon
            style={{ color: Theme.color.BLUE_3 }}
            icon={faCode}
          />
        }
      >
        Codechef
      </MaterialButton>
      {/* codeforces */}
      <MaterialButton
        style={{ width: "80%", marginTop: "1%" }}
        variant="outlined"
        color="primary"
        href="https://codeforces.com/profile/avcb"
        target="_blank"
        startIcon={
          <FontAwesomeIcon
            style={{ color: Theme.color.BLUE_3 }}
            icon={faCode}
          />
        }
      >
        Codeforces
      </MaterialButton>
    </Wrapper>
  );
};
